import { components } from '@/themes/MUITheme/components';
import { LightPalette } from '@/themes/MUITheme/palette';
import { defaultTypography } from '@/themes/MUITheme/typography';
import { alpha, createTheme } from '@mui/material/styles';

/** The theme a retailer's own users see, built from the retailer's brand color. */
export const createRetailerTheme = (brandColor: string) => {
  const baseRetailerTheme = createTheme({
    palette: {
      ...LightPalette,
      primary: { main: brandColor },
      primaryContainer: alpha(brandColor, .18),
    },
  });

  return createTheme({
    components: components(baseRetailerTheme),
    palette: baseRetailerTheme.palette,
    typography: defaultTypography,
  });
};
